import React from "react";

export const StatCard = ({ label, value, sub, icon: Icon, accent, testid, delay = 0 }) => {
  return (
    <div
      data-testid={testid}
      className="animate-fade-up group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-shadow duration-300 hover:shadow-md"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
          <p className="mt-2 font-display text-3xl font-extrabold tracking-tight text-slate-900">{value}</p>
          {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
        </div>
        <div
          className="grid h-11 w-11 place-items-center rounded-xl"
          style={{ backgroundColor: accent ? `${accent}1a` : "#0f172a14", color: accent || "#0f172a" }}
        >
          {Icon && <Icon className="h-5 w-5" />}
        </div>
      </div>
      <div
        className="absolute -bottom-10 -right-10 h-24 w-24 rounded-full opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-20"
        style={{ backgroundColor: accent || "#0f172a" }}
      />
    </div>
  );
};
